(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e || window.DifraxHotspotsLoaded) return;
	window.DifraxHotspotsLoaded = !0;
	let t = (e) => e?.closest?.(`[data-hotspots]`),
		n = (e) => e?.querySelector(`[data-hotspots-overlay]`),
		r = (e) => e?.querySelector(`[data-hotspots-overlay-panel]`),
		i = (e) => e?.querySelector(`[data-hotspots-overlay-content]`),
		a = (e) => e?.querySelector(`[data-hotspots-marker].is-active`),
		o = (e, t) => e?.querySelector(`[data-hotspot-template="${t}"]`),
		s = () =>
			window.matchMedia?.(`(prefers-reduced-motion: reduce)`)?.matches ?? !1,
		c = (e) => {
			e?.querySelectorAll(`[data-hotspots-marker]`).forEach((e) => {
				e.classList.remove(`is-active`),
					e.setAttribute(`aria-expanded`, `false`);
			});
		},
		l = (e, t, n) => {
			if (!e || !t || !n) return;
			let r = e.querySelector(`.hotspots__media-frame`);
			if (!r) return;
			let i = r.getBoundingClientRect(),
				a = t.getBoundingClientRect(),
				o = n.getBoundingClientRect(),
				s = a.left + a.width / 2 - i.left,
				c = a.top + a.height / 2 - i.top,
				l = a.height / 2,
				u = c + l + 12,
				d = s - o.width / 2;
			u + o.height > i.height - 8 && (u = c - l - 12 - o.height),
				(d = Math.max(8, Math.min(d, i.width - o.width - 8))),
				(u = Math.max(8, Math.min(u, i.height - o.height - 8))),
				(n.style.left = `${d}px`),
				(n.style.top = `${u}px`);
		},
		u = (e) => {
			let t = n(e),
				i = r(e);
			!t || t.hidden || (i?.classList.remove(`is-open`), (t.hidden = !0), c(e));
		},
		d = (e) => {
			let t = n(e),
				i = r(e);
			if (!t || t.hidden) return;
			if (!i?.classList.contains(`is-open`) || s()) {
				u(e);
				return;
			}
			i.classList.remove(`is-open`);
			let a = !1,
				o,
				c = () => {
					a ||
						((a = !0),
						i.removeEventListener(`transitionend`, l),
						o !== void 0 && window.clearTimeout(o),
						u(e));
				},
				l = (e) => {
					e.target === i && c();
				};
			i.addEventListener(`transitionend`, l), (o = window.setTimeout(c, 220));
		},
		f = (e, t) => {
			let a = n(e),
				u = r(e),
				d = i(e),
				f = t?.dataset?.hotspotId,
				p = o(e, f);
			if (!a || !u || !d || !p) return;
			let m = !a.hidden && u.classList.contains(`is-open`);
			c(e),
				t.classList.add(`is-active`),
				t.setAttribute(`aria-expanded`, `true`),
				(d.innerHTML = p.innerHTML),
				u.classList.remove(`is-open`),
				(a.hidden = !1),
				window.requestAnimationFrame(() => {
					if ((l(e, t, u), m || s())) {
						u.classList.add(`is-open`), u.focus();
						return;
					}
					window.requestAnimationFrame(() => {
						u.classList.add(`is-open`), u.focus();
					});
				});
		};
	document.addEventListener(`click`, (e) => {
		let r = e.target.closest(`[data-hotspots-marker]`);
		if (r) {
			let e = t(r);
			if (!e) return;
			if (a(e) === r && !n(e)?.hidden) {
				d(e);
				return;
			}
			f(e, r);
			return;
		}
		e.target.closest(`[data-hotspots-overlay-panel]`) ||
			document.querySelectorAll(`[data-hotspots]`).forEach((e) => {
				n(e)?.hidden || d(e);
			});
	}),
		document.addEventListener(`keydown`, (e) => {
			e.key === `Escape` &&
				document.querySelectorAll(`[data-hotspots]`).forEach((e) => {
					n(e)?.hidden || d(e);
				});
		}),
		e.register({
			name: `hotspots`,
			selector: `[data-hotspots]`,
			init() {},
			update(e) {
				let t = a(e),
					i = r(e);
				t && i && !n(e)?.hidden && l(e, t, i);
			},
		});
})();
